import React from 'react';
import PropTypes from 'prop-types';
import {CREATE_SIGNUP_PATH} from '../../constants/routePaths';
import {
  PageWrapper,
  PageTitle,
  Card,
  CardTitle,
  Lead,
  PrepBox,
  IntroHeading,
  HowList,
  HowItem,
  HowNumber,
  Actions,
  StartButton,
} from './NewReferralPage.style';

const HOW_IT_WORKS_STEPS = [
  "Enter the business's contact details.",
  'Upload a recent invoice and let us know whether it was a delivery or collection order.',
  'Review and confirm the details.',
  "See the comparison — a clear, line-by-line breakdown of exactly what they could save with JJ Foodservice. We'll then check everything and email the new customer once it's approved.",
];

const NewReferralPage = ({history}) => {
  const startReferral = () => history.push(CREATE_SIGNUP_PATH);

  return (
    <PageWrapper>
      <PageTitle>New Business Referral</PageTitle>
      <Card>
        <CardTitle>Refer a new business to JJ Foodservice</CardTitle>
        <Lead>
          Know a business that would enjoy the quality, service and value JJ
          Foodservice is known for? Refer them here in about two minutes — all
          it takes is one of their recent supplier invoices.
        </Lead>

        <PrepBox>
          <strong>See how much they could save with JJ Foodservice:</strong> we
          compare their invoice against JJ Foodservice prices, line by line, and
          show them exactly what they&apos;d save on each product by switching
          to everyday low prices.
        </PrepBox>

        <IntroHeading>How it works</IntroHeading>
        <HowList>
          {HOW_IT_WORKS_STEPS.map((step, i) => (
            <HowItem key={step}>
              <HowNumber>{i + 1}</HowNumber>
              <span>{step}</span>
            </HowItem>
          ))}
        </HowList>

        <PrepBox>
          <strong>Before you start, have handy:</strong> the business&apos;s
          email and phone number, and a recent trade invoice.
        </PrepBox>

        <Actions>
          <StartButton onClick={startReferral}>Start a referral</StartButton>
        </Actions>
      </Card>
    </PageWrapper>
  );
};

NewReferralPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default NewReferralPage;
